export default (num: number | null | undefined): string => {
  if (!num && num !== 0) {
    return '-'
  }
  const rounded: number = num / 100

  let result: string = rounded.toFixed(2)
  result = result.replace(/\.00$/, '')
  result = result.replace('.', ',')
  result = `${result} €`
  return result
}
